// extracted by mini-css-extract-plugin
module.exports = {"input_box":"login_input_box__OZOje","div":"login_div__GGy6t","form_container":"login_form_container__3ky-K","button":"login_button__3ZkYS"};